















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import enumsModule from '@/store/modules/enumsModule';
import {NodeDataType, NodeTypeName} from '@/system/nodes/enums';
import {NodeData, parentType} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';
import {ServiceData} from '@/services/interfaces';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {PModule, PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import {ServiceName} from '@/services/enums';
import {groupBy} from 'lodash';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import {getAllTasks} from '@/store/modules/entities/pmodules/pmoduleTasksModule';

@Component({
  computed: {
    NodeTypeName() {
      return NodeTypeName;
    },
  },
  components: {Loading, SimpleDialog, SelectionList},
})
export default class NodesTreeEditDialog extends Vue {
  loading = true;

  error = false;
  oldNodeType: NodeData | null = null;
  //Доступные сервисы
  @Prop({required: true})
  services!: ServiceData[];

  @Prop({required: true})
  node!: NodeData | null;

  @Prop({required: true})
  parent: parentType | null = null;

  @Watch('showAllPM')
  async changePMList(newVal: any) {
    if (newVal && this.selectedService == ServiceName.Workload)
      this.pmodules = this.allPmodules.filter(
        x =>
          x.type == PModuleType.MonitorStatesTasks ||
          x.type == PModuleType.MonitorBoundaryTasks ||
          x.type == PModuleType.MonitorChildTasks,
      );

    if (!newVal && this.selectedService == ServiceName.Workload)
      this.pmodules = this.allPmodules.filter(
        x =>
          (x.nodes &&
            x.nodes?.filter(pos => pos.node_id == this.node?.id).length > 0 &&
            x.type == PModuleType.MonitorStatesTasks) ||
          x.type == PModuleType.MonitorBoundaryTasks ||
          x.type == PModuleType.MonitorChildTasks,
      );
  }

  nodeModel: NodeData = {name: '', type: NodeDataType.Company, parent: {name: '', type: 6}};

  dialog = false;

  fieldRequiredRules = [(v: any) => !!v || 'Поле обязательно для заполнения'];
  formValid = false;

  btnIndex: number | null = null;
  btnActiveState = false;

  filterNodeTypes: {description: string; value: number}[] = [];

  //Привязанные сервисы узла
  nodeServices: {name: string; description: string; guids: string[]; moduleNames: string}[] = [];

  showAllPM = false;

  get nodeTypes() {
    const oldType = this.node?.type;
    if (oldType) {
      if (oldType === NodeDataType.Other) {
        return enumsModule.nodeDataTypes.filter(item => item.value >= NodeDataType.MachineUnit);
      }
      return enumsModule.nodeDataTypes.filter(item => item.value >= oldType);
    }
    return enumsModule.nodeDataTypes;
  }

  @Watch('node')
  async onChangeNode() {
    this.filterNodeTypes = this.nodeTypes;
  }

  @Watch('dialog')
  async onDialog(value: boolean) {
    if (!value) this.updateBtnState();
    else {
      try {
        if (this.node) {
          const {data} = await nodeModule.edit(this.node.id);
          this.nodeModel = data;
        }

        this.$nextTick(() => {
          if (this.$refs.form) (this.$refs.form as any).validate();
        });
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }

  updateBtnState() {
    this.btnActiveState = this.dialog;
    this.btnIndex = this.dialog ? 0 : null;
  }

  transformServices() {
    const services: any[] = [];
    this.nodeServices.forEach((service: any) => {
      const pmodules = service.guids.map(
        (guid: string) => this.allPmodules.filter((m: PModule) => m.guid === guid)[0],
      );
      const groups = groupBy(pmodules, 'type');
      const modules: any[] = [];
      for (const key in groups) {
        if (key === 'undefined') continue;
        modules.push({
          type:
            key == `${PModuleType.MonitorStatesTasks}` ||
            key == `${PModuleType.MonitorBoundaryTasks}` ||
            key == `${PModuleType.MonitorChildTasks}`
              ? `${PModuleType.HeaterMonitorModule}`
              : key,
          guids: groups[key].map((m: PModuleWithMeasurements) => m.guid),
        });
      }

      if (modules.length) services.push({name: service.name, modules: modules});
    });
    return services;
  }

  onSubmit() {
    this.dialog = false;
    this.updateBtnState();
    this.nodeModel.services = this.transformServices();
    this.$emit('submitForm', this.nodeModel);
  }

  async created() {
    await pmoduleModule.fetchAll();
    const allTasks = await getAllTasks();
    this.allPmodules = [...pmoduleModule.all].concat(allTasks);
    this.checkPermiss();
    this.oldNodeType = this.node;
  }

  onClickCancel() {
    this.dialog = false;
  }

  pmodulesLoading = true;
  pmodulesError = false;

  enableToViewCoolant = false;

  @Watch('node')
  async onLoadedNode() {
    await this.loadPModules();
  }

  // Модель узла получена, группируем модули по услугам и получаем их наименования
  @Watch('nodeModel')
  async onLoadedNodeModel() {
    let services = this.services;
    if (!this.enableToViewCoolant) services = services.filter(x => x.name != 'coolant');

    this.nodeServices = services.map((s: ServiceData) => {
      const service = this.nodeModel.services.filter((item: any) => item.name === s.name)[0];
      let guids: string[] = [];
      if (service)
        guids = service.modules.reduce((arr: any, el: any) => {
          return arr.concat([...el.guids]);
        }, []);

      const moduleNames = guids.map((guid: string) => {
        const pmodule = this.pmodules.filter(m => m.guid === guid)[0];
        if (pmodule) return pmodule.name;
        const amodule = this.allPmodules.filter(m => m.guid === guid)[0];
        if (amodule) return amodule.name;
        return guid;
      });

      return {
        name: s.name,
        description: s.description,
        guids: guids,
        moduleNames: moduleNames.join(', '),
      };
    });
  }

  checkPermiss() {
    const permisString = localStorage.getItem('permissions');
    let permissions = [];
    if (permisString) permissions = JSON.parse(permisString);

    const bool = permissions.some((permis: any) => permis.obj == 'coolant_service');
    this.enableToViewCoolant = bool;
  }

  // Загружаем список модулей узла
  async loadPModules() {
    try {
      this.pmodulesLoading = true;
      this.pmodulesError = false;
      if (this.node?.id) {
        this.pmodules = await nodeModule.getModules(this.node.id);
      }
    } catch {
      this.pmodulesError = true;
    } finally {
      this.pmodulesLoading = false;
    }
  }

  // Список программных модулей
  pmodules: PModule[] = [];

  // Список всех программных модулей
  allPmodules: PModule[] = [];

  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  // Диалоговое окно для выбора программных модулей
  pmodulesDialog = false;

  // Список выбранных программных модулей
  selectedPModulesGuids: string[] = [];

  selectedService: ServiceName | null = null;

  onClickedTextfield(item: any) {
    this.selectedPModulesGuids = item.guids;
    this.selectedService = item.name;
    if (this.selectedService == ServiceName.Workload)
      this.pmodules = this.allPmodules.filter(
        x =>
          x.nodes &&
          x.nodes?.filter(pos => pos.node_id == this.node?.id).length > 0 &&
          x.type == PModuleType.HeaterMonitorModule,
      );
    else
      this.pmodules = this.allPmodules.filter(
        x => x.nodes && x.nodes?.filter(pos => pos.node_id == this.node?.id).length > 0,
      );
    this.pmodulesDialog = true;
  }

  onSelectPModules() {
    const service = this.nodeServices.filter((s: any) => s.name === this.selectedService)[0];
    if (!service) return;

    service.guids = this.selectedPModulesGuids;

    service.moduleNames = service.guids
      .map((guid: string) => {
        const pmodule = this.pmodules.filter((m: PModule) => m.guid === guid)[0];
        if (pmodule) return pmodule.name;
        const amodule = this.allPmodules.filter((m: PModule) => m.guid === guid)[0];
        if (amodule) return amodule.name;
        return guid;
      })
      .join(', ');

    this.pmodulesDialog = false;
  }
}
